module.exports = __webpack_public_path__ + "img/changes-white.3658b06f.svg";